module.exports = __webpack_public_path__ + "img/772.8869d80d.gif";